<template>
    <main class="register">
        <div class="page-header">
            <h1 class="page-header__title">Rejestracja</h1>
        </div>
        <transition name="fade">
            <CouponCode v-if="step === 'CouponCode'" @complete="nextStep($event)"/>
            <RegisterForm v-if="step === 'registerForm'" @complete="nextStep($event)"/>
            <AuthCode v-else-if="step === 'code'"/>
        </transition>
    </main>
</template>

<script>
import RegisterForm from '@/components/register/RegisterForm'
import AuthCode from '@/components/register/AuthCode'
import CouponCode from '@/components/register/CouponCode'

export default {
    name: "Register",
    components: {
        RegisterForm,
        AuthCode,
        CouponCode
    },
    data() {
        return {
            step: 'CouponCode'
        }
    },
    methods: {
        nextStep(currentStep) {
            if (currentStep === 'CouponCode') this.step = 'registerForm';
            if (currentStep === 'registerForm') this.step = 'code';
        }
    }
};
</script>

<style lang="scss">
.register {
    flex: 1;

    &-actions {
        text-align: center;
        font-size: 14px;
        margin-top: 30px;
        flex-wrap: nowrap;

        &__item {
            flex: 1;
        }

        &__link {
            font-weight: bold;
            color: #85b904;
        }
    }

    &__row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        margin: 12px 0;
        position: relative;

        &--margin {
            margin-top: 20px;
        }

        input {
            border: 2px solid #e1e1e1;
            border-radius: 20px;
            height: 40px;
            box-sizing: border-box;
            width: 100%;
            font-size: 18px;
            padding: 0 0 0 40px;
            outline: none;
            transition: all 200ms;

            &:focus {
                border-color: #85b904;
                box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
            }
        }

        img {
            position: absolute;
            left: 13px;
            top: 8px;
        }
    }
}
</style>
